import PlayerNameModal from "./PlayerNameModal";

export default PlayerNameModal;
